export const GET_PRODUCTS = 'GET_PRODUCTS';
export const CREATE_PRODUCTS = 'CREATE_PRODUCTS';
export const EDIT_PRODUCTS = 'EDIT_PRODUCTS';
export const DELETE_PRODUCTS = 'DELETE_PRODUCTS';
